import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';
import { svgUrl } from '../../utils/staticUrls';

const ProductColorSwatchesStyles = css`
  .color-swatch-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    /* Ensure natural height expansion */
    min-height: auto;
    height: auto;
  }

  .expandable-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .expand-swatch {
      align-self: start;
      font-size: ${typography.sm};
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:hover {
        background-color: ${colors.gray.shade3};
      }
    }
  }

  .plus-icon {
    background-image: url(${svgUrl('plus.svg')});
    background-repeat: no-repeat;
    background-size: contain;
    height: 12px;
    width: 12px;
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;
  }

  .minus-icon {
    background-image: url(${svgUrl('minus.svg')});
    background-repeat: no-repeat;
    background-size: contain;
    height: 12px;
    width: 12px;
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;
  }

  .collapse-text {
    border-bottom: 1px solid #333333;
  }

  .mkp-color-swatch {
    margin-bottom: 17px;
  }

  .color-swatch-HARDLINE {
    width: 100%;
    @mixin tabletToDesktop {
      max-width: 305px;
    }
  }

  .color-swatch-SOFTLINE {
    width: 100%;
  }
`;

export { ProductColorSwatchesStyles };
